import serviceBuilder from './serviceBuilder';

export default ({
  serviceConfig = [], serviceActionHandlers, accessToken, widgetAPIServerHost, amsAPIServerHost,
}) => (
  serviceConfig.map(({ service, url, ...configRest }) => ({
    [service]: serviceBuilder({
      url,
      urlProps: { accessToken, widgetAPIServerHost, amsAPIServerHost },
      ...serviceActionHandlers,
      ...configRest,
    }),
  })).reduce((acc, fn) => Object.assign(acc, fn), {})
);
